import axios from 'axios'
import { useRouter } from 'next/router'
import type { ReactElement } from 'react'
import { createContext, useContext, useEffect, useState } from 'react'

import { useBrand } from './useBrand'

type Props = {
  children: ReactElement
}

const DealerContext = createContext<string | undefined>(undefined)

const DealerProvider = ({ children }: Props) => {
  const router = useRouter()
  const brand = useBrand()
  const [dealerObj, setdealerObj] = useState(false)
  const [preferredDealer, setPreferredDealer] = useState('')
  const { dealer, centre, centreId, dealerID, dealerId, otso, olso } =
    router.query
  let query = dealer || centre || centreId || dealerID || dealerId || ''

  useEffect(() => {
    const { referrer } = document

    if (referrer) {
      // Start listening to AEM response
      window.addEventListener(
        'message',
        (event) => {
          if (event.data.id !== 'gb_aem_getPreferredDealer') {
            return
          }

          // eslint-disable-next-line @typescript-eslint/no-shadow
          const { dealer } = event.data

          if (dealer) {
            setPreferredDealer(dealer)
          }
        },
        false,
      )

      // Post message to AEM
      const message = {
        id: 'gb_form_getPreferredDealer',
      }
      window.parent.postMessage(message, referrer)
    }
  }, [])

  useEffect(() => {
    async function getDealer(queryDealer) {
      try {
        const response = await axios.post(
          `${process.env.NEXT_PUBLIC_API}/dealers`,
          {
            dealer: queryDealer,
            servicing: !!otso || !!olso,
          },
        )

        if (response?.data[0]?._source?.brands[0].toLowerCase() !== brand) {
          return false
        }

        return response.data
      } catch (error) {
        return false
      }
    }

    async function checkDealer() {
      if (!query && preferredDealer) {
        query = preferredDealer
      }

      if (query) {
        const res = await getDealer(query)
        if (res) {
          setdealerObj(res[0]._source)
          // eslint-disable-next-line no-console
          console.log(
            `[GB] Dealer/Center in querystring: ${res[0]._source.brands[0]} - ${res[0]._source.name} - ${res[0]._source.applications.NMSC.externalID} - ${res[0]._source.uuid}`,
          )

          window.tngaDataLayer.dealer = {
            name: res[0]._source.name,
            dealerId: res[0]._source.uuid,
            city: res[0]._source.addresses[0].city,
            zipcode: res[0]._source.addresses[0].zip,
          }
        }
      }
    }

    checkDealer()
  }, [query, brand, preferredDealer])

  return (
    <DealerContext.Provider value={dealerObj}>
      {children}
    </DealerContext.Provider>
  )
}

const useDealer = () => {
  return useContext(DealerContext)
}

export { DealerProvider, useDealer }
